/**
 * Coming Soon — early access sign-up
 *
 * Vanilla JS, no dependencies. Submits the email field straight to Klaviyo's
 * client-side "Create Client Subscription" API (no server / app required):
 * https://developers.klaviyo.com/en/reference/create_client_subscription
 *
 * The form element carries two data attributes, set from section settings:
 *   data-klaviyo-company-id  → Klaviyo public API key ("Site ID")
 *   data-klaviyo-list-id     → Klaviyo list ID to subscribe the profile to
 *
 * The form itself stays hidden by default — a secondary text link
 * ([data-coming-soon-toggle], pointing at the form's id via aria-controls)
 * reveals it on click. Nothing about the Klaviyo submit flow above changes;
 * this only controls whether the form is visible.
 */
(function () {
  'use strict';

  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  var KLAVIYO_REVISION = '2024-10-15';

  function init() {
    var forms = document.querySelectorAll('[data-coming-soon-form]');
    for (var i = 0; i < forms.length; i++) {
      forms[i].addEventListener('submit', handleSubmit);
    }

    var toggles = document.querySelectorAll('[data-coming-soon-toggle]');
    for (var j = 0; j < toggles.length; j++) {
      toggles[j].addEventListener('click', handleToggleClick);
    }
  }

  function handleToggleClick(event) {
    var toggle = event.currentTarget;
    var targetId = toggle.getAttribute('aria-controls');
    var target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;

    var isHidden = target.hasAttribute('hidden');
    if (isHidden) {
      target.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
      var input = target.querySelector('input[type="email"]');
      if (input) input.focus();
    } else {
      target.setAttribute('hidden', 'hidden');
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    var form = event.currentTarget;
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var messageEl = form.parentElement
      ? form.parentElement.querySelector('[data-coming-soon-message]')
      : null;
    var email = input && input.value ? input.value.trim() : '';
    var companyId = form.getAttribute('data-klaviyo-company-id') || '';
    var listId = form.getAttribute('data-klaviyo-list-id') || '';

    clearMessage(messageEl);

    if (!isValidEmail(email)) {
      showMessage(messageEl, 'Please enter a valid email address.', 'error');
      if (input) input.focus();
      return;
    }

    if (!companyId || !listId || isPlaceholder(companyId) || isPlaceholder(listId)) {
      showMessage(messageEl, "Sign-up isn't connected yet — please check back soon.", 'error');
      return;
    }

    setLoading(form, button, true);

    var endpoint = KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(companyId);
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          },
          custom_source: 'Coming Soon Page'
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        setLoading(form, button, false);

        if (response.ok) {
          form.setAttribute('hidden', 'hidden');
          showMessage(messageEl, "You're on the list.", 'success');
        } else {
          showMessage(messageEl, 'Something went wrong — please try again.', 'error');
        }
      })
      .catch(function () {
        setLoading(form, button, false);
        showMessage(messageEl, 'Something went wrong — please try again.', 'error');
      });
  }

  function isPlaceholder(value) {
    return /^PLACEHOLDER_/.test(value);
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function setLoading(form, button, isLoading) {
    form.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    if (!button) return;
    button.disabled = isLoading;
    button.textContent = isLoading ? 'Joining…' : 'Join';
  }

  function showMessage(el, text, state) {
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
    el.classList.remove('coming-soon__form-message--error', 'coming-soon__form-message--success');
    el.classList.add('coming-soon__form-message--' + state);
  }

  function clearMessage(el) {
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
    el.classList.remove('coming-soon__form-message--error', 'coming-soon__form-message--success');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
